import { FormInstance } from "antd";
import { validateEmail } from "../../../utils/utilities/validateEmail";
import { AgentLoginFieldType } from "../types/types";
import { ValidateFormErrorMessages } from "../../../constants/validateFormErrorMessages";

/**
 * Проверка и назначение сообщений ошибок при выводе фокуса с поля ввода email
 *
 * @param {FormInstance<AgentLoginFieldType>} form
 * @returns {() => void}
 */
export const handleBlurEmail =
  (form: FormInstance<AgentLoginFieldType>) => () => {
    const email = form.getFieldValue("email");
    if (typeof email === "string") {
      if (email.length === 0) {
        form.setFields([
          { name: "email", errors: [ValidateFormErrorMessages["required"]] },
        ]);
        return;
      }

      if (!validateEmail(email)) {
        form.setFields([
          {
            name: "email",
            errors: [ValidateFormErrorMessages["enterCorrectEmail"]],
          },
        ]);
        return;
      }
    }
  };

/**
 * Скрытие сообщений об ошибок в форме, при вводе пользователем символа для полей email и пароля
 *
 * @param {FormInstance<AgentLoginFieldType>} form
 * @param {keyof AgentLoginFieldType} key
 * @returns {() => void}
 */
export const handleChangeInputHideFormError =
  (form: FormInstance<AgentLoginFieldType>, key: keyof AgentLoginFieldType) =>
  () => {
    form.setFields([{ name: key, errors: undefined }]);
  };

/**
 * Проверка и назначение сообщений ошибок при выводе фокуса с поля ввода пароля
 *
 * @param {FormInstance<AgentLoginFieldType>} form
 * @returns {() => void}
 */
export const handleBlurPassword =
  (form: FormInstance<AgentLoginFieldType>) => () => {
    const password = form.getFieldValue("password");

    if (typeof password === "string" && password.length === 0) {
      form.setFields([
        { name: "password", errors: [ValidateFormErrorMessages["required"]] },
      ]);
    }
  };
